module.exports = __webpack_public_path__ + "img/mn.5a9dafd8.png";